import { queryNetworkByApiVersion } from "./queryNetworkByApiVersion";

export function currentContractsQueryApiVersion(): Parameters<
    typeof queryNetworkByApiVersion
>[0] {
    return "v2";
}
